// Unpublished Work © 2023-2025 Deere & Company.

import t from 'tcomb';
import {CrossReferenceDetail} from './cross-reference-detail';
import {PageStatus} from '../page-status';

export const CrossReferences = t.struct({
    allCrossReferences: t.list(CrossReferenceDetail),
    numberOfCrossReferences: t.Number,
    crossReferencesStatus: PageStatus,
    removeCustomerVisibilityLoadingStatus: t.maybe(PageStatus)
}, {
    defaultProps: {
        allCrossReferences: [],
        numberOfCrossReferences: 0,
        crossReferencesStatus: PageStatus.meta.map.COMPLETE,
        removeCustomerVisibilityLoadingStatus: PageStatus.meta.map.COMPLETE
    },
    name: 'CrossReferences',
    strict: true
});
